import React from 'react';

import i18n from '../../i18n';

// @mui
import { TextField } from '@mui/material';

/**
 * Numeric input.
 *
 * This used to keep its own error state and, crucially, *not* call onChange when
 * the input failed its check — so the form kept the last valid number while the
 * box showed something else, and Save submitted the stale value. It is now
 * controlled and always reports what the user typed; the numeric rule in
 * utils/fieldValidation decides whether that is acceptable and blocks Save.
 */
export default class DialogNumberField extends React.Component {
    render() {
        const { field, value, error, autoFocus, onBlur } = this.props;
        const translatedName = i18n.t(`columns.${field.label}`);

        return (
            <TextField
                key={field.id}
                autoFocus={autoFocus}
                id={field.id}
                // Text with a decimal keypad, not type="number": that one shows
                // the browser's locale, so Fee read "0,5" beside a Minimal
                // commission of "0.2". A typed comma is taken as the point.
                type="text"
                inputProps={{ inputMode: 'decimal' }}
                label={translatedName}
                required={Boolean(field.required)}
                error={Boolean(error)}
                // A validation message replaces the static hint while it is
                // showing, as in DialogPercentField.
                helperText={
                    error ||
                    (field.helperText
                        ? i18n.t(`helperTexts.${field.helperText}`)
                        : '')
                }
                // `value`, not `defaultValue`: uncontrolled meant the field
                // ignored anything set programmatically, including a template.
                value={value ?? ''}
                fullWidth
                onBlur={onBlur}
                onChange={(event) =>
                    this.props.onChange(
                        field.id,
                        event.target.value.replace(',', '.')
                    )
                }
            />
        );
    }
}
